export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SETUP_MESSAGES = 'SETUP_MESSAGES'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'

export function setupMessages({ setup, user, locale }) {
  return dispatch => {
    dispatch({
      type: SETUP_MESSAGES,
      customerMessage: setup.app_message,
      tcmMessage:
        setup.white_label !== 'ice'
          ? setup.tcm_messages?.find(message => message.language === locale?.replace('nb', 'no'))
              ?.text
          : null,
      userMessage: user.appMessage,
    })
  }
}

export function addMessage(headline, message, showOnlyOnce = false) {
  return dispatch => {
    dispatch({
      type: ADD_MESSAGE,
      headline: headline,
      message: message,
      showOnlyOnce: showOnlyOnce,
    })
  }
}

export function removeMessage(idx) {
  return dispatch => {
    dispatch({
      type: REMOVE_MESSAGE,
      idx: idx,
    })
  }
}
